(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
  new Swiper(sectionEl, {
  slidesPerView: 'auto',
  centeredSlides: true,
  spaceBetween: 16,
  grabCursor: true,
  breakpoints: {
    0: {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 12
    },
    768: {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 20
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
